import React, {Component} from 'react';
import TriggerButton from "../components/ModalForm/TriggerButton";
import EmailGroupTable from "../components/Table/EmailGroupTable";
import PropTypes from "prop-types";
import Operations from "../enums/Operations";
import TableTypes from "../enums/TableTypes";
import Modal from "../components/ModalForm/Modal";
import generalUtil from "../utils/GeneralUtil";
import restUtil from "../utils/RestUtil";

const propTypes = {
    axios: PropTypes.func.isRequired
};

const emailGroupsTriggerText = 'Create Email Group';

export class EmailGroupPage extends Component
{
    constructor(props) {
        super(props);
        this.state = {
            modalIsShown: false,
            emailGroups: []
        }
        this.handleEmailGroupChange = this.handleEmailGroupChange.bind(this);
    }

    showModal = () => {
        this.setState({modalIsShown: true});
        generalUtil.toggleScrollLock();
    };

    closeModal = () => {
        this.setState({
            modalIsShown: false,
            emailGroups: [],
        });
        if (this.TriggerButton !== undefined) {
            this.TriggerButton.focus();
        }
        generalUtil.toggleScrollLock();
    };

    // Handles change of user input in the email groups field when creating a new email group
    handleEmailGroupChange(emailGroups) {
        this.setState({
            emailGroup: emailGroups
        });
    }

    // Submit function for Email Group create button
    emailGroupsOnSubmit = (event) => {
        event.preventDefault(event);
        this.closeModal();
        this.setState({
            data: {
                name: event.target.name.value,
                email: event.target.email.value,
                defaultEmailGroup: event.target.defaultEmailGroup.checked
            }
        }, () => {
            restUtil.postRequest(this.props.axios, '/sevbot/emailGroups/createEmailGroup', this.state.data);
        });
    };

    render() {
        return (
            <React.Fragment>
                {this.state.modalIsShown ? (<Modal
                    onSubmit={this.emailGroupsOnSubmit}
                    closeModal={this.closeModal}
                    onKeyDown={generalUtil.onKeyDown}
                    tableType={TableTypes.EmailGroups}
                    operation={Operations.Create}
                    axios={this.props.axios}
                    onEmailGroupChange={this.handleEmailGroupChange}
                    selectedEmailGroups={this.state.emailGroups}
                />) : null}
            <div className='tableContainer'>
                <TriggerButton
                    showModal={this.showModal}
                    buttonRef={(n) => (this.TriggerButton = n)}
                    triggerText={emailGroupsTriggerText}
                />
                <EmailGroupTable axios={this.props.axios}/>
            </div>
            </React.Fragment>
        )
    }
}
EmailGroupPage.propTypes = propTypes;
export default EmailGroupPage;